import type { Component } from "vue";

export const routes = [
  {
    path: "/transfers/manage",
    name: "transfer-manager",
    component: (): Promise<Component> => import("./views/TransferManager.vue"),
    meta: { requiresAuth: true, requiredRoles: [], requiredGroups: [] },
  },
  {
    path: "/transfers/fba/:id",
    name: "transfer-fba-editor",
    component: (): Promise<Component> => import("./views/TransferFBAEditor.vue"),
    meta: { requiresAuth: true, requiredRoles: [], requiredGroups: [] },
  },
  {
    path: "/transfers/:id",
    name: "transfer-editor",
    component: (): Promise<Component> => import("./views/TransferEditor.vue"),
    meta: { requiresAuth: true, requiredRoles: [], requiredGroups: [] },
  },
  {
    path: "/transfers/fba/:id/pack",
    name: "transfer-pack-ship",
    component: (): Promise<Component> => import("./views/TransferPackShip.vue"),
    meta: { requiresAuth: true, requiredRoles: [], requiredGroups: [] },
  },
];
